import { DatePicker, Form, Input, Select, Spin } from "antd";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import svg92 from "../../../../../assets/svg/svg92.svg";
import svg85 from "../../../../../assets/svg/svg85.svg";
import { convertToMinutes, formatText, normalizeTime } from "../../../../../utils"; 
import Manual from "./Manual";
import Block from "./block/Block";
import { cleanAuto, cleanBlock } from "../../../../../features/folder/folderSlice";
import toast from "react-hot-toast";
import { save, saveArray } from "../../../../../features/save/saveSlice";
import Auto from "./auto/Auto";

const { TextArea } = Input;
function ActivityScheduling({ handleNext, handleBack, form }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handlePrev = async () => {
    await handleBack();
  };
  const { rowId, selectedCandidates } = useSelector((state) => state.folder);
  const { saving } = useSelector((state) => state.save);
  const [active, setActive] = useState("Block_Time");
  const options = ["Block_Time", "Auto_Schedule", "Manual"];

  const handleActive = async (label) => {
    await dispatch(cleanBlock());
    await dispatch(cleanAuto())
    await setActive(label);
  };

  const { activeObjActivity } = useSelector((state) => ({
    activeObjActivity: state.folder.activeObj["activity"], 
  })); 
   
  const {autoObj} =  useSelector((state)=>state.folder) 
  async function handleSubmitStep() { 
    if (active === "Block_Time" || active === "Manual") {
      const payloadData = selectedCandidates?.map(({ docs, ...rest }) => ({
        ...rest,
        docs: docs?.map((d) => ({
          docId: d?.docId,
          docName: d?.docName,
          docType: d?.docType,
          docFile: d?.docFile,
        })),
      }));

      const res = await dispatch(
        saveArray({
          url: "api/v1/applications/batch-update",
          data: payloadData,
        })
      );
      if (res?.payload?.success) {
        await toast.success(res?.payload?.messages?.message);
        await navigate("/recruitment/activity-list");
      } else {
        toast.error(res?.payload?.messages?.message);
      }
    }else if (active === "Auto_Schedule"){
      if(selectedCandidates?.length < 1){
        toast.error("Select atleast one candidate")
        return
      }
      const res = await dispatch(
        saveArray({
          url: "api/v1/applications/auto-batch",
          jobApplicationIds: selectedCandidates?.map((item)=>item?.japId),
          startTime:normalizeTime(autoObj?.startTime),
          breakTime:convertToMinutes(autoObj?.breakTime),
          duration:convertToMinutes(autoObj?.duration),
          jaaId:activeObjActivity?.jaaId
        })
      );
      if (res?.payload?.success) {
        await toast.success(res?.payload?.messages?.message);
        await navigate("/recruitment/activity-list");
      } else {
        toast.error(res?.payload?.messages?.message);
      }
    }else{
      console.log("null")
    }
  }
  return (
    <>
      <div className="text-lightBlack text-[1.5rem] font-dmSans font-[600]">
        Activity Scheduling
      </div>
      <div className="text-[#0E0E0E] text-[1.125rem] font-[500] font-dmSans">
        Fill with relevant infomation
      </div>

      <div className="flex items-center gap-[1rem] mt-[2.5rem]">
        {options?.map((label) => (
          <button
            key={label}
            className={`min-h-[1.25rem] px-[1rem] py-[.5rem] items-center justify-center rounded-[1.625rem] gap-[.25rem]
        ${
          active === label
            ? "bg-lightBlack text-white"
            : "bg-white text-lightBlack border border-[#E9E9E9]"
        }`}
            type="button"
            onClick={() => handleActive(label)}
          >
            {formatText(label)}
          </button>
        ))}
      </div>

      <div className="mt-[2.5rem]">
        {active === "Auto_Schedule" ? (
          <Auto form={form} />
        ) : active === "Block_Time" ? (
          <Block />
        ) : active === "Manual" ? (
          <Manual />
        ) : null}
      </div>

      <div className="flex lg:flex-row flex-col lg:items-center justify-between lg:gap-0  gap-5 w-full mt-[3.5rem]">
        <div
          className="flex items-center text-[#706F6F] text-[.875rem] font-[400] font-dmSans gap-3 cursor-pointer"
          onClick={() => handlePrev()}
        >
          <img src={svg85} alt="svg85" /> Back
        </div>
        <div className="justify-end flex items-center gap-x-2">
          <div className="w-[100px]">
            <button
              key="back"
              type="button"
              className="cstm-btn-2"
              onClick={() => handlePrev()}
            >
              Cancel
            </button>
          </div>

          <div className="w-[150px]">
            <button
              key="submit"
              type="submit"
              className="cstm-btn"
              onClick={handleSubmitStep}
            >
              <span className="flex items-center gap-x-3">
                {saving ? (
                  <Spin />
                ) : (
                  <>
                    Submit <img src={svg92} alt="svg92" />
                  </>
                )}
              </span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ActivityScheduling;
